import React from 'react';

/**
 * RevUpAI logomark — clean bold "R" as a single path
 */
export default function RevUpMark({ size = 36, color = '#ffffff' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="
          M20 14
          L20 86
          L36 86
          L36 58
          L54 58
          L70 86
          L88 86
          L70 56
          C80 52 86 44 86 34
          C86 22 76 14 62 14
          Z
          M36 26
          L60 26
          C66 26 70 30 70 34
          C70 38 66 46 60 46
          L36 46
          Z
        "
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
}